<script>
  import { useLocation } from "svelte-navigator";
  import { pageTitleStore } from "@stores/pageTitleStore.js";

  const location = useLocation();

  function normalizeTitlePart(value) {
    const title = `${value || ""}`.trim();
    return title && !title.startsWith("define ") ? title : "";
  }

  $: pathname = $location?.pathname || window.location.pathname;
  $: search = $location?.search || window.location.search;
  $: projectName = new URLSearchParams(search).get("project");
  $: headerTitle =
    $pageTitleStore.pathname === pathname
      ? normalizeTitlePart($pageTitleStore.breadcrumb) ||
        normalizeTitlePart($pageTitleStore.section)
      : "";
  $: viewTitle = headerTitle || projectName || "";
  $: title = viewTitle ? `${viewTitle} • paxray` : "paxray";
</script>

<svelte:head>
  <title>{title}</title>
</svelte:head>
